import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LoginComponent } from './pages/auth/login/login.component'
import { LogoutComponent } from './pages/auth/logout/logout.component'
import { HomeComponent } from './pages/home/home.component'
import { AuthGuard } from './common/guards/auth.guard'
import { UserCreateEditComponent } from './resources/user/user-create-edit/user-create-edit.component'
import { CompanyCreateEditComponent } from './resources/company/company-create-edit/company-create-edit.component'
import { IsAdminGuard } from './common/guards/is-admin.guard'
import { IsLocalAdminGuard } from './common/guards/is-local-admin.guard'
import { UserListComponent } from './resources/user/user-list/user-list.component'
import { CompanyListComponent } from './resources/company/company-list/company-list.component'
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component'
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component'
import { MissionListComponent } from './resources/mission/mission-list/mission-list.component'
import { MissionCreateEditComponent } from './resources/mission/mission-create-edit/mission-create-edit.component'
import { SampleDetailComponent } from './resources/sample/sample-detail/sample-detail.component'
import { WeighingCreateEditComponent } from './resources/weighing/weighing-create-edit/weighing-create-edit.component'
import { Error404Component } from './errors/error404/error404.component'
import { SampleListComponent } from './resources/sample/sample-list/sample-list.component'
import { SampleCreateEditComponent } from './resources/sample/sample-create-edit/sample-create-edit.component'
import { MissionDetailComponent } from './resources/mission/mission-detail/mission-detail.component'
import { SamplePreCreateComponent } from './resources/sample/sample-pre-create/sample-pre-create.component'
import { environment } from '../environments/environment'
import { IsAdminOrLocalAdminGuard } from './common/guards/is-admin-or-local-admin.guard'

const routes: Routes = [
  // Auth
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },

  // Pages
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },

  // Users
  {
    path: 'users',
    component: UserListComponent,
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    path: 'users/create',
    component: UserCreateEditComponent,
    data: { mode: 'create' },
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    path: 'users/:id/edit',
    component: UserCreateEditComponent,
    data: { mode: 'edit' },
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
 // Companies
  {
    path: 'companies',
    component: CompanyListComponent,
    canActivate: [AuthGuard, IsAdminGuard]
  },
  {
    path: 'companies/create',
    component: CompanyCreateEditComponent,
    data: { mode: 'create' },
    canActivate: [AuthGuard, IsAdminGuard]
  },
  {
    path: 'companies/:id/edit',
    component: CompanyCreateEditComponent,
    data: { mode: 'edit' },
    canActivate: [AuthGuard, IsAdminGuard]
  },

  // Missions
  {
    path: 'missions',
    component: MissionListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'missions/create',
    component: MissionCreateEditComponent,
    data: { mode: 'create' },
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    path: 'missions/:id',
    component: MissionDetailComponent,
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    path: 'missions/:id/edit',
    component: MissionCreateEditComponent,
    data: { mode: 'edit' },
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    // Duplication : réutilise le formulaire de création, pré-rempli depuis la
    // mission source (nouvelles entités catégories/sous-catégories/champs).
    path: 'missions/:id/duplicate',
    component: MissionCreateEditComponent,
    data: { mode: 'duplicate' },
    canActivate: [AuthGuard, IsAdminOrLocalAdminGuard]
  },
  {
    path: 'missions/:missionId/samples/create',
    component: SampleCreateEditComponent,
    data: { mode: 'createFromMission' },
    canActivate: [AuthGuard]
  },

  // Samples
  {
    path: 'samples',
    component: SampleListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'samples/create',
    component: SamplePreCreateComponent,
    data: { mode: 'create' },
    canActivate: [AuthGuard]
  },
  {
    path: 'samples/:id',
    component: SampleDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'samples/:id/edit',
    component: SampleCreateEditComponent,
    data: { mode: 'edit' },
    canActivate: [AuthGuard]
  },
  {
    path: 'samples/:sampleId/weighings/create',
    component: WeighingCreateEditComponent,
    data: { mode: 'createFromSample' },
    canActivate: [AuthGuard]
  },
  {
    path: 'samples/:sampleId/weighings/:weighingId/edit',
    component: WeighingCreateEditComponent,
    data: { mode: 'editFromSample' },
    canActivate: [AuthGuard]
  },

  // Other
  {
    path: '404',
    component: Error404Component,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: environment.nativescriptEmbedded })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
